import localeAntd from 'antd/es/locale/en_US'

const messages = {
  'text.basicDetails': 'Basic Details',
  'text.depositSettings': 'Reservation Deposit Settings',
  'form.label.restaurant_message': 'Do you want to show restaurant message?',
  'text.onlineReservation': 'Online Reservation Setup',
  'text.contactInformation': 'Contact Information',
  'title.reservation.setup': 'Reservation Setup',
  'form.label.reservationInterval': 'Your Preferred Reservation Interval',
  'form.label.minimumTimeToBook': 'Minimum Time to Book a Reservation',
  'form.label.maximumDayToBook': 'Maximum Time to Book a Reservation',
  'form.label.mealDuration': 'Meal Duration',
  'text.restaurantMessage': 'Restaurant Message',
  'form.label.charge_deposit': 'Charge deposit for reservations?',
  'form.label.discount_repeat_customers': 'Do you want to offer a loyalty discount for repeat customers?',
  'form.label.eligibility_type': 'Eligibility Type',
  'form.label.total_orders_value': 'Total Orders Value',
  'form.label.order_discount_type': 'Order Discount Type',
  'form.label.dollar_off': 'Dollar Off',
  'form.label.percentage_off': 'Percentage Off',
  'form.label.allow_refund': 'Allow to refund the deposit when a reservation is cancelled?',
  'form.label.processing_fee': 'Refund the deposit minus the processing fees?',
  'form.placeholder.restaurant_message': 'Enter your restaurant messages',
  'form.label.cancellation_policy_message': 'Cancellation Policy Message',
  'form.placeholder.cancellation_policy_message': 'Enter your cancellation policy message',
  'action.addBlockedDate': 'Block Date(s)',
  'text.updateBlockedDate': 'Update Blocked Date',
  'text.removeBlockedDate': 'Remove Blocked Date',
  'text.removeBlockedDate.description': 'Are you sure you want to remove this date?',
  'form.placeholder.blockedDate.description': 'Enter a reason for blocking these dates',
  'action.addHolidayDate': 'Holiday Hour(s)',
  'text.updateHolidayDate': 'Update Holiday Hour',
  'text.removeHolidayDate': 'Remove Holiday Hour',
  'text.addHolidayDate': 'Add Holiday Hour(s)',
  'text.holidayDetails': 'Holiday Hours',
  'form.label.holidayReason': 'Holiday reason',
  'form.placeholder.holiday.description': 'Enter a reason for holiday',
  'form.label.reason': 'Blocked reason',
  'form.label.blockOptions': 'Block Options',
  'form.select.host': 'Host',
  'form.select.online': 'Online',
  'text.addBlockedDate': 'Add Block Date(s)',
  'text.blockDetails': 'Reservation Blocked Dates',
  'text.fromDate': 'From Date',
  'text.toDate': 'To Date',
  'text.reason': 'Reason',
  'text.restaurantName': 'Restaurant Name',
  'text.deliveryAddress': 'Delivery Address',
  'action.foodDeliveryURL': 'Food Delivery Platform URLs',
  'action.linkLocation': 'Link Location',
  'text.searchLocation': 'Search Location',
  'form.label.email.search': 'Enter the account email for the location that you want to link',
  'form.placeholder.search.email': 'Search by email',
  'action.send_verification_email': 'Send Verification Email',
  'text.removeBusiness': 'Remove Business',
  'text.removeBusiness.description': 'Do you want to remove this business?.',
  'text.updateFoodDeliveryPlatform': 'Update Food Delivery Platform',
  'form.label.platfrom.name': 'Platform Name',
  'form.label.platfrom.url': 'Ordering URL',
  'title.businessLinked': 'Business Linked Location',
  'title.timesheet_reports': 'Timesheet Reports',
  'title.timesheets': 'Timesheets',
  'action.previewWebsite': 'Preview Website',
  'action.add': 'Add',
  'action.addCoupon': 'Add Coupon',
  'action.addBlog': 'Add Blog',
  'action.addCustomImage': 'Add Custom Image',
  'action.addLocation': 'Add Location',
  'action.addTax': 'Add Tax',
  'action.addUser': 'Add User',
  'action.cancel': 'Cancel',
  'action.change': 'Change',
  'action.changeColor': 'Change Color',
  'action.choose': 'Choose',
  'action.confirm': 'Confirm',
  'action.connect': 'Connect',
  'action.customerPortalBgImg': 'Customer Portal Background Image',
  'action.download': 'Download',
  'action.downloadTemplate': 'Download Template',
  'action.edit': 'Edit',
  'action.export': 'Export',
  'action.forgotPassword': 'Forgot password?',
  'action.giftCardPromotion': 'Gift Card Promotion',
  'action.gotoSignIn': 'Go to Sign in',
  'action.import': 'Import',
  'action.issue': 'Issue',
  'action.issueGiftCard': 'Issue Gift Card',
  'action.logout': 'Logout',
  'action.next': 'Next',
  'action.manage': 'Manage',
  'action.no': 'No',
  'action.recoverPassword': 'Recover my password',
  'action.redeem': 'Redeem',
  'action.reload': 'Reload',
  'action.remove': 'Remove',
  'action.resend': 'Resend',
  'action.resendEmail': 'Resend Email',
  'action.resetPassword': 'Reset my password',
  'action.save': 'Save',
  'action.search': 'Search',
  'action.select': 'Select',
  'action.send': 'Send',
  'action.signIn': 'Sign in',
  'action.signUp': 'Sign up',
  'action.update': 'Update',
  'action.upload': 'Upload',
  'action.view': 'View',
  'action.viewDetails': 'View Details',
  'action.viewReceipt': 'View Receipt',
  'action.viewStore': 'View Store',
  'action.yes': 'Yes',
  'action.generateReport': 'Generate report',
  'form.placeholder.popupurl': 'Enter the promotion popup url',

  'text.custommessage.closedorder': 'No closed orders to show',
  'text.reportType': 'Order Type',
  'text.reportCount': 'Count',
  'text.reportSales': 'Sales',
  'text.reportTax': 'Taxes',
  'text.reportCreditDebit': 'Credit/Debit',
  'text.reportTip': 'Tip',
  'text.reportcash': 'Cash',
  'action.exporttopdf': 'Export To PDF',
  'action.exporttoexcel': 'Export To Excel',

  'text.due': 'Due:',
  'text.placed': 'Placed:',
  'text.dollar': '$',
  'text.cancel': 'Cancel',
  'text.confirm': 'Confirm',
  'text.complete': 'Complete',
  'text.readyForPickup': 'Ready for Pickup',
  'text.ondelivery': 'On Delivery',
  'text.refundOrder': 'Refund order',
  'text.subTotal': 'SubTotal',
  'text.discount': 'Discount',
  'text.tax': 'Tax',
  'text.taxExemption': 'Tax Exemption',
  'text.total': 'Total',
  'text.tip': 'Tip',
  'text.changeEstimatedTime': 'Change estimated time?',
  'text.confirmTimeChange': 'Confirm Time Change',

  'text.true': 'True',
  'text.false': 'False',
  'form.label.aboutUsImage': 'About Us Image',
  'form.label.dateRange': 'Date Range',
  'text.option.today': 'Today',
  'text.option.yesterday': 'Yesterday',
  'text.option.thisWeek': 'This Week',
  'text.option.lastWeek': 'Last Week',
  'text.option.thisMonth': 'This Month',
  'text.option.lastMonth': 'Last Month',
  'text.option.customDateRange': 'Custom Date Range',

  'text.upload': 'Upload',
  'form.comboForm.cardTitle': 'Basic Combo Info',
  'form.itemForm.cardTitle': 'Basic Item Info',
  'form.itemName.required': 'Item Name is required',
  'form.comboName.required': 'Combo Name is required',
  'form.itemName.minimum.required': 'Please add atleast 3 characters for item name',
  'form.itemName.maximum.required': 'Maximum 20 characters allowed in item name',
  'form.comboName.minimum.required': 'Please add atleast 3 characters for combo name',
  'form.comboName.maximum.required': 'Maximum 20 characters allowed in combo name',
  'form.placeholder.itemName': 'Item Title',
  'form.placeholder.comboName': 'Combo Title',
  'form.label.itemName': 'Item Name',
  'form.label.comboName': 'Combo Name',
  'form.placeholder.description': 'Item Desciption',
  'form.placeholder.comboDescription': 'Combo Desciption',
  'form.label.category': 'Category',
  'form.itemCategory.required': 'Item Category is required',
  'form.placeholder.category': 'Select a category',
  'form.label.combineModifierGroup': 'Combine the maximum allowed modifier with another modifier group',
  'form.placeholder.combineModifierGroup': 'Select a modifier group',
  'form.label.itemprice': 'Item Price',
  'form.itemPrice.required': 'Item Price is required',
  'form.label.comboprice': 'Combo Price',
  'form.label.combodiscount': 'Combo Discount',
  'form.comboPrice.required': 'Combo Price is required',
  'form.minPurchaseValue.required': 'Minimum Purchase Value is required',
  'form.discountValue.required': 'Discount Value is required',
  'form.discountType.required': 'Discount Type is required',
  'form.placeholder.itemPrice': '123.99',
  'form.label.tax': 'Set custom taxes for this item',
  'form.label.taxValue': 'Item Taxes',
  'form.label.taxes': 'Taxes',
  'form.label.track': 'Automatically track item stock count from Clover inventory',
  'form.label.trackValue': 'Item Count',
  'form.label.stock': 'Automatically track item stock count',
  'form.label.hideItem': 'Hide this item from menu page',
  'form.customTax.required': 'Custom Tax is Required',
  'form.itemCount.required': 'Item count is Required',
  'form.orderLimit.required': 'Order Limit is Required',
  'form.error.orderLimit.min': 'Order Limit must be more than 1',
  'form.error.clover_service_charge_missing': 'Need to add service charge in Clover dashboard',
  'form.placeholder.customTax': '13',
  'form.placeholder.itemCount': '10',
  'form.label.internalDisplayName': 'KDS/Kitchen Printer Name',
  'form.internalDisplayName.required': 'Internal Display is required',
  'form.label.mostPopular': 'Most Popular',
  'text.popularItems': 'Is this among your popular items?',
  'form.cardTitle.photo': 'Photo',
  'form.label.photo': 'Upload high quality image for the item',
  'form.cardTitle.modifierGroups': 'Modifier Groups',
  'form.placeholder.modifierGroups': 'Select a modifier group',
  'form.cardTitle.itemAvailability': 'Item Availability',
  'form.cardTitle.promotion': 'Promotions',
  'form.label.calorieCount': 'Calorie Count',
  'form.label.spiceLevel': 'Spice Level',
  'form.label.tags': 'Tags',
  'form.placeholder.spiceLevel': 'Select a spice level',
  'text.hours': 'Hours',
  'text.sameAsStoreHours': 'Same as Store hours',
  'text.specifySpecialHours': 'Specify special hours for this item',
  'text.sunday': 'S',
  'text.monday': 'M',
  'text.tuesday': 'T',
  'text.wednesday': 'W',
  'text.thursday': 'T',
  'text.friday': 'F',
  'text.saturday': 'S',
  'text.day.sunday': 'Sunday',
  'text.day.monday': 'Monday',
  'text.day.tuesday': 'Tuesday',
  'text.day.wednesday': 'Wednesday',
  'text.day.thursday': 'Thursday',
  'text.day.friday': 'Friday',
  'text.day.saturday': 'Saturday',
  'text.item': 'Item',
  'text.combo': 'Combo',
  'text.title.removeCategory': 'Remove Category',
  'text.title.removeMenuItem': 'Remove Menu Item',
  'text.title.removeCombo': 'Remove Menu Combo',
  'text.drawerTitle.addItem': 'Add Item',
  'text.drawerTitle.addCombo': 'Add Combo',
  'text.drawerTitle.updateItem': 'Update Item',
  'text.drawerTitle.updateCombo': 'Update Combo',
  'text.description.removeCategoryModal':
    'Deleting this category will also delete all the items inside it.',
  'text.description.removeMenuItemModal': 'Delete this menu item.',
  'text.description.removeComboModal': 'Delete this combo.',

  'desc.backgroundImage': 'Background Image',
  'desc.barcode': 'Barcode',
  'desc.icon': 'Icon',

  'empty.image': 'No images.',
  'empty.staffs': 'No users has been added.',

  'form.error.deliveryfees': 'Delivery fees should not be more than 3 digits or less than $999',
  'form.error.orderValueTxt': 'Order value should not be more than 3 digits or less than $999',
  'form.error.orderValueCustomTxt': 'Order value should be more than delivery min. amount',
  'form.error.delivery_minimum_amount':
    'Delivery Minimum should not be more than 4 digits or less than $9999',
  'form.error.amount.required': 'Please input the amount',
  'form.error.businessAddress.required': 'Please input the business address',
  'form.error.businessAddress.max': 'Business address must be up to 180 characters',
  'form.error.businessDays.required': 'Please select at least 1 day',
  'form.error.businessName.required': 'Please input the business name',
  'form.error.businessName.max': 'Business name must be up to 64 characters',
  'form.error.code.max': 'Code must be up to 20 characters',
  'form.error.code.min': 'Code must be min 3 characters',
  'form.error.coupon.minPurchaseValue':
    'Minimum Purchase Value should be higher than the Coupon Value',
  'form.error.disallow.specialChars': 'Special characters are not allowed',
  'form.error.contactPhone.invalid': 'Invalid contact phone number',
  'form.error.contactPhone.alt.invalid': 'Invalid alt. contact phone number',
  'form.error.email.required': 'Please input the email address',
  'form.error.email.type': 'Invalid email address',
  'form.error.email.max': 'Email address must be up to 64 characters',
  'form.error.empty.select': 'No matches found.',
  'form.error.firstName.required': 'Please input the first name',
  'form.error.firstName.max': 'First name must be up to 64 characters',
  'form.error.lastName.required': 'Please input the last name',
  'form.error.lastName.max': 'Last name must be up to 64 characters',
  'form.error.locationAddress.required': 'Please input the location address',
  'form.error.locationAddress.max': 'Business address must be up to 180 characters',
  'form.error.loginPin.length': 'Must be a 4 digit pin',
  'form.error.password.required': 'Please input the password',
  'form.error.password.min': 'Password must be at least 8 characters',
  'form.error.password.max': 'Password must be up to 32 characters',
  'form.error.password.match': "Passwords doesn't match",
  'form.error.phone.invalid': 'Invalid phone number',
  'form.error.phone.required': 'Please input the phone number',
  'form.error.required': 'Required',

  'form.helper.coupon.channel': 'Coupon will be valid only at the selected channels',
  'form.helper.coupon.minPurchaseValue':
    'Apply coupon for Gift Card value above or equal to Min. purchase value',
  'form.helper.coupon.orderType': 'Coupon will be valid only for the selected order types',
  'form.helper.recipientEmail': 'Digital card will be sent to this email',
  'form.helper.senderEmail': 'A copy of the digital card will be sent to this email',
  'form.placeholder.youtubeVideoID': 'Enter your youtube video ID',
  'form.label.buyOneGetOne': 'Buy 1 Get 1 Free',
  'form.label.buyTwoGetOne': 'Buy 2 Get 1 Free',
  'form.label.buyThreeGetOne': 'Buy 3 Get 1 Free',
  'form.label.buyOneGetFifty': 'Buy 1 Get 1 50% OFF',
  'form.label.freeItem': 'Free Item',
  'form.label.itemDiscount': 'Item Discount',
  'form.label.bannerImage': 'Banner Image',
  'form.label.firstbannerheading': 'Banner Heading Text',
  'form.placeholder.firstbannerheading': 'Enter the Banner Heading text',
  'form.label.firstbannerheadingcolor': 'Banner Heading Text Color',
  'form.label.firstbannersubheading': 'Banner Sub Heading Text',
  'form.placeholder.firstbannersubheading': 'Enter the Banner Sub Heading Text',
  'form.label.firstbannersubheadingcolor': 'Banner Sub Heading Text Color',
  'form.label.calltoactiontext': 'Call to Action Button Text',
  'form.placeholder.calltoactiontext': 'Enter the call to Action Button Text',
  'form.label.calltoactiontextcolor': 'Call to Action Button Background Color',
  'form.label.calltoactionurl': 'Call to Action URL',
  'form.placeholder.calltoactionurl': 'Enter the call to Action URL',
  'form.placeholder.custompageurl': 'Enter the custom page URL',
  'form.placeholder.googledoclink': 'Enter the Google Doc URL',

  'form.label.aboutUsSubBanner': 'Sub Banner Image',
  'form.label.gallerySubBannerImage': 'Sub Banner Image',
  'form.label.contactUsSubBannerImage': 'Sub Banner Image',
  'form.label.aboutUsHeading': 'Heading',
  'form.placeholder.aboutUsHeading': 'Enter the Heading',
  'form.label.aboutUsSubHeading': 'Sub Heading',
  'form.placeholder.aboutUsSubHeading': 'Enter the Sub Heading',
  'form.label.aboutUsPageDescription': 'Description',
  'form.placeholder.aboutUsPageDescription': 'Enter the Description',

  'form.label.menuSubBannerImage': 'Sub Banner Image',
  'form.placeholder.customerdomain': 'www.plento.io',
  'form.placeholder.custompagename': 'Enter the custom page name',

  'form.label.websiteTitle': 'Website Page Title',
  'form.placeholder.websiteTitle': 'Enter the Page Title',

  'form.label.websiteDescription': 'Website Page Description',
  'form.placeholder.websiteDescription': 'Enter the Page Description',

  'form.placeholder.Script': 'Enter the Script Code',

  'form.label.websiteKeywords': 'Website Page Keywords',
  'form.placeholder.websiteKeywords': 'Enter the Page Keywords',

  'form.label.secondbannerheading': 'Heading Text',
  'form.placeholder.secondbannerheading': 'Enter the Headind',
  'form.label.secondbannersubheading': 'Sub Heading Text',
  'form.placeholder.secondbannersubheading': 'Enter the Sub Heading',

  'form.label.thirdbannerheading': 'Heading Text',
  'form.placeholder.thirdbannerheading': 'Enter the Heading',
  'form.label.thirdbannersubheading': 'Sub Heading Text',
  'form.placeholder.thirdbannersubheading': 'Enter the Sub Heading',

  'form.label.googleAnalytics': 'Google Analytics code',
  'form.placeholder.googleAnalytics': 'Enter the Google Analytics Code',

  'form.label.businessLogoHyperlink': 'Business Logo Hyperlink',
  'form.placeholder.businessLogoHyperlink': 'Enter the business logo hyperlink url',

  'form.label.facebookPixel': 'Facebook Pixel ID',
  'form.placeholder.facebookPixel': 'Enter the facebook Pixel ID',
  'form.placeholder.googleTagScript': 'Enter the google ads tag ID',

  'form.label.googlePlacesId': 'Google Places ID',
  'form.placeholder.googlePlacesId': 'Enter the Google Places ID',

  'form.label.facebook': 'Facebook URL',
  'form.placeholder.facebook': 'Enter the Facebook profile url',

  'form.label.twitter': 'Twitter URL',
  'form.placeholder.twitter': 'Enter the Twitter profile url',

  'form.label.linkedin': 'Linkedin URL',
  'form.placeholder.linkedin': 'Enter the Linkedin profile url',

  'form.placeholder.tiktok': 'Enter the Tiktok profile url',

  'form.label.instagram': 'Instagram URL',
  'form.placeholder.instagram': 'Enter the Instagram profile url',

  'form.label.youtube': 'Youtube URL',
  'form.placeholder.youtube': 'Enter the Youtube page url',

  'form.label.yelp': 'Yelp URL',
  'form.placeholder.yelp': 'Enter the Yelp url',

  'form.label.galleryimage': 'Upload Image',
  'action.uploadImage': 'Upload Image',
  'text.empty': '    ',

  'form.label.active': 'Active',
  'form.label.address': 'Address',
  'form.label.allowManageCoupons': 'Allow to Manage Coupons?',
  'form.label.allowManageCustomers': 'Allow to Manage Customers?',
  'form.label.allowManageDeliveryRadius': 'Allow to Manage Delivery Radius?',
  'form.label.allowManageIntegrations': 'Allow to Manage Integrations?',
  'form.label.allowManageMenu': 'Allow to Manage Menu?',
  'form.label.allowManageOnlineOrderSettings': 'Allow to Manage Online Store Setup?',
  'form.label.allowManageOrders': 'Allow to Manage Orders?',
  'form.label.allowManageUsers': 'Allow to Manage Users?',
  'form.label.allowRedeemCard': 'Allow to Redeem Card?',
  'form.label.allowReloadCard': 'Allow to Reload Card?',
  'form.label.allowRunReport': 'Allow to Run Reports?',
  'form.label.altPhone': 'Alt. Phone Number',
  'form.label.appId': 'App ID',
  'form.label.backgroundColor': 'Background Color',
  'form.label.backgroundImage': 'Background Image',
  'form.label.businessAddress': 'Business Address',
  'form.label.businessName': 'Business Name',
  'form.label.businessType': 'Business Type',
  'form.label.channel': 'Channel',
  'form.label.email': 'Email',
  'form.label.email.current': 'Current Email',
  'form.label.email.new': 'New Email',
  'form.label.from': 'From',
  'form.label.city': 'City',
  'form.label.cloneMenuLocation': 'Menu Clone Location',
  'form.label.code': 'Code',
  'form.label.contactName': 'Owner Name',
  'form.label.contactFirstName': 'First Name',
  'form.label.contactLastName': 'Last Name',
  'form.label.contactPhone': 'Owner Phone Number',
  'form.label.contactPhone.alt': 'Alt. Phone Number',
  'form.label.coupon.autoApplyCheckout': 'Apply coupon automatically at checkout?',
  'form.label.coupon.code': 'Coupon Code',
  'form.label.coupon.minPurchaseValue': 'Minimum Purchase Value',
  'form.label.coupon.discountType': 'Discount Type',
  'form.label.coupon.discountValue': 'Discount Value',
  'form.label.coupon.type': 'Coupon Type',
  'form.label.combo.type': 'Combo Type',
  'form.label.coupon.value': 'Coupon Value',
  'form.label.country': 'Country',
  'form.label.cardNumber': 'Card Number',
  'form.label.creditCard': 'Credit Card',
  'form.label.cvv': 'CVV',
  'form.label.description': 'Description',
  'form.label.deliveryDate': 'Delivery Date',
  'form.label.employeeId': 'Employee ID',
  'form.label.expiry': 'Expiry Date',
  'form.label.firstName': 'First Name',
  'form.label.giftCardBalance': 'Gift Card Balance',
  'form.label.giftCardCopy': 'Send a copy of Gift Card?',
  'form.label.giftCardNumber': 'Gift Card Number',
  'form.label.giftCardType': 'Gift Card Type',
  'form.label.image': 'Image',
  'form.label.language': 'Language',
  'form.label.language.preferred': 'Preferred Language',
  'form.label.lastName': 'Last Name',
  'form.label.location': 'Location',
  'form.label.locationAddress': 'Location Address',
  'form.label.loginPin': 'Login Pin',
  'form.label.hourlyWage': 'Hourly Wage',
  'form.label.assignDriver': 'Delivery Driver',
  'form.label.driverType': 'Driver Type',
  'form.label.deliveryCharge': 'Delivery Charge Per Order',
  'form.label.maxUsageLimit': 'Maximum Usage Limit per Customer',
  'form.label.merchantId': 'Merchant ID',
  'form.label.message': 'Message',
  'form.label.minPurchaseValue': 'Minimum Purchase Value',
  'form.label.name': 'Name',
  'form.label.orderType': 'Order Type',
  'form.label.customerEligibility': 'Customer Eligibility',
  'form.label.password': 'Password',
  'form.label.password.new': 'New Password',
  'form.label.password.confirm': 'Confirm Password',
  'form.label.payment': 'Payment',
  'form.label.paymentMethod': 'Payment Method',
  'form.label.paymentBy': 'Payment By',
  'form.label.percent': 'Percent',
  'form.label.phone': 'Phone Number',
  'form.label.pin': 'Pin',
  'form.label.postalCode': 'Postal Code',
  'form.label.province': 'Province',
  'form.label.redeemValue': 'Redeem Value',
  'form.label.rePassword': 'Re-Password',
  'form.label.reloadValue': 'Reload Value',
  'form.label.retypeLoginPin': 'Retype Login Pin',
  'form.label.role': 'Role',
  'form.label.stateProvince': 'State/Province',
  'form.label.storeName': 'Store Name',
  'form.label.storeType': 'Store Type',
  'form.label.color': 'Color',
  'form.label.textColor': 'Text Color',
  'form.label.themeColor': 'Theme Color',
  'form.label.timezone': 'Timezone',
  'form.label.to': 'To',
  'form.label.transactionType': 'Transaction Type',
  'form.label.user': 'User',
  'form.label.userId': 'User ID',
  'form.label.zipPostalCode': 'Zip/Postal Code',
  'form.label.website': 'Website',
  'form.label.locationName': 'Location Name',
  'form.placeholder.website': 'Enter the website url',
  'form.placeholder.locationName': 'Enter the location name',
  'form.label.orderEmail': 'Order Notification Email',
  'form.label.deliveryOrderEmail': 'Delivery Driver Notification Email',
  'form.label.deliveryOrderSMS': 'Delivery Driver Notification SMS',

  'form.placeholder.printername': 'Printer Name',
  'form.placeholder.address': 'Enter the address',
  'form.placeholder.altPhone': 'Enter the alt. phone number',
  'form.placeholder.businessCity': 'City',
  'form.placeholder.businessCountry': 'Country',
  'form.placeholder.businessName': 'Enter the business name',
  'form.placeholder.businessPostalCode': 'Postal code',
  'form.placeholder.businessProvince': 'Province',
  'form.placeholder.businessType': 'Select the business type',
  'form.placeholder.amount': '0.00',
  'form.placeholder.cardName': 'Name on card',
  'form.placeholder.cardNumber': '4242 4242 4242 4242',
  'form.placeholder.city': 'Select the city',
  'form.placeholder.cloneMenuLocation': 'Select the location',
  'form.placeholder.contactName': 'Enter the contact name',
  'form.placeholder.contactFirstName': 'Enter the first name',
  'form.placeholder.contactLastName': 'Enter the last name',
  'form.placeholder.contactPhone': 'Enter the contact phone number',
  'form.placeholder.contactPhone.alt': 'Enter the alt. phone number',
  'form.placeholder.coupon.code': 'Coupon code',
  'form.placeholder.coupon.description': 'Short description about the coupon',
  'form.placeholder.coupon.value': 'Coupon value',
  'form.placeholder.country': 'Select the country',
  'form.placeholder.customerEmail': 'Enter the customer email',
  'form.placeholder.customerName': 'Enter the customer name',
  'form.placeholder.customerPhone': 'Enter the customer phone number',
  'form.placeholder.email': 'Enter the email',
  'form.placeholder.email.current': 'Enter the current email address',
  'form.placeholder.email.new': 'Enter the new email address',
  'form.placeholder.expirationMonth': 'MM',
  'form.placeholder.expirationYear': 'YY',
  'form.placeholder.firstName': 'Enter the first name',
  'form.placeholder.giftCardBalance': 'Enter the gift card balance',
  'form.placeholder.giftCardNumber': 'xxxxxxxxxxxxxxxx',
  'form.placeholder.language': 'Select the language',
  'form.placeholder.lastName': 'Enter the last name',
  'form.placeholder.location.name': 'Enter the location name',
  'form.placeholder.location': 'Select the location',
  'form.placeholder.loginPin': 'Enter the 4-digit login pin',
  'form.placeholder.message': 'Enter a personalised message',
  'form.placeholder.recipientEmail': "Enter the recipient's email",
  'form.placeholder.recipientName': "Enter the recipient's full name",
  'form.placeholder.recipientPhone': "Enter the recipient's phone number",
  'form.placeholder.password': 'Enter the password',
  'form.placeholder.password.account': 'Your account password',
  'form.placeholder.password.confirm': 'Enter the new password again',
  'form.placeholder.password.new': 'Enter the new password',
  'form.placeholder.percent': '0',
  'form.placeholder.phone': 'Enter the phone number',
  'form.placeholder.postalCode': 'Enter the postal code',
  'form.placeholder.province': 'Select the province',
  'form.placeholder.rePassword': 'Enter the password again',
  'form.placeholder.retypeLoginPin': 'Enter the 4-digit login pin again',
  'form.placeholder.role': 'Select the role',
  'form.placeholder.search': 'Search..',
  'form.placeholder.search.cardNumber': 'Search by card number..',
  'form.placeholder.search.coupon': 'Search by code, description..',
  'form.placeholder.search.blog': 'Search by title..',
  'form.placeholder.search.customer': 'Search by name, phone..',
  'form.placeholder.search.staff': 'Search by name, email..',
  'form.placeholder.search.tax': 'Search Tax',
  'form.placeholder.senderEmail': "Enter the sender's email",
  'form.placeholder.senderName': "Enter the sender's full name",
  'form.placeholder.senderPhone': "Enter the sender's phone number",
  'form.placeholder.stateProvince': 'Select the state/province',
  'form.placeholder.storeName': 'Enter the store name',
  'form.placeholder.storeType': 'Enter the store type',
  'form.placeholder.streetAddress': 'Street address',
  'form.placeholder.colorCode': 'Enter Color Code',
  'form.placeholder.tax.name': 'Enter the tax name',
  'form.placeholder.timezone': 'Select the timezone',
  'form.placeholder.transactionType': 'Select the timezone',
  'form.placeholder.user': 'Select the user',
  'form.placeholder.users': 'Select the users for this location',
  'form.placeholder.taxes': 'Select the taxes for this location',
  'form.placeholder.zipPostalCode': 'Enter the zip/postal code',
  'form.error.blog.title.max': 'Title must be up to 250 characters',
  'form.error.blog.title.min': 'Title must be min 3 characters',
  'form.error.blog.slug.max': 'Slug must be up to 250 characters',
  'form.error.blog.slug.min': 'Slug must be min 3 characters',
  'form.label.blog.title': 'Title',
  'form.placeholder.blog.title': 'Blog title',
  'form.label.blog.slug': 'Slug',
  'form.label.blog.photo': 'Upload high quality image for the feature image',
  'form.label.meta.description': 'Meta Description',
  'form.label.meta.keywords': 'Meta Keywords',
  'form.placeholder.meta.description': 'Enter the Meta Description',
  'form.placeholder.meta.keywords': 'Enter the Meta Keywords',

  'form.select.all': 'All',
  'form.select.card': 'Card',
  'form.select.cash': 'Cash',
  'form.select.delivery': 'Delivery',
  'form.select.dineIn': 'Dine In',
  'form.select.employee': 'Employee',
  'form.select.english': 'English',
  'form.select.french': 'French',
  'form.select.inStore': 'In-Store',
  'form.select.manager': 'Manager',
  'form.select.onlineStore': 'Online Store',
  'form.select.owner': 'Owner',
  'form.select.pickup': 'Pickup',
  'form.select.times': '{count, plural, =1{1 time} other{# times}}',
  'form.select.unlimited': 'Unlimited',
  'form.select.limit': '{count, plural, =0{Max} other{#}}',
  'form.select.cateringPickup': 'Catering - Pickup',
  'form.select.cateringDelivery': 'Catering - Delivery',

  'helper.dragDropImage': 'Click or drag image to this area to upload',

  // common links
  'link.termsService': 'Terms of Service',
  'link.privacyPolicy': 'Privacy Policy',

  'note.logoSize':
    'Image dimension should be 230px × 87px in JPG or PNG format with the size less than 1MB.',

  'progress.resendingEmail': 'Resending email..',
  'progress.uploading': 'Uploading.. please wait..',
  'progress.verifyingCode': 'Verifying the code..',

  'tab.giftEasyGallery': 'Gift Easy Gallery',
  'tab.upload': 'Upload',
  'tab.yourLibrary': 'Your Library',
  'text.addBlog': 'Add Blog',
  'text.accountInfo': 'Account Info',
  'text.action': 'Action',
  'text.active': 'Active',
  'text.activity': 'Activity',
  'text.addCoupon': 'Add Coupon',
  'text.addLocation': 'Add Location',
  'text.addUser': 'Add User',
  'text.addTax': 'Add Tax',
  'text.address': 'Address',
  'text.alreadyHaveAccount': 'Already have an account?',
  'text.and.spaced': ' and ',
  'text.amount': 'Amount',
  'text.applyLocations': 'Apply to Locations',
  'text.assignLocations': 'Assign Locations',
  'text.authNumber': 'Auth. Number',
  'text.businessProfile.title': 'Business Profile',
  'text.businessProfile.description':
    'Tell us about your business so we can help you set it up to accept payments.',
  'text.byUser': 'By {name} - {location}',
  'text.card': 'Card',
  'text.changeEmail': 'Change Email',
  'text.chooseImage': 'Choose Image',
  'text.city': 'City',
  'text.cloneMenu': 'Clone Menu',
  'text.clover': 'Clover',
  'text.cloverIntegrationInfo': 'Clover Integration Info',
  'text.code': 'Coupon Code',
  'text.title': 'Title',
  'text.published': 'Published',
  'text.notPublished': 'Not Published',
  'text.draft': 'Draft',
  'text.created': 'Created',
  'text.modified': 'Modified',
  'text.confirmEmail.title': 'Confirm Email',
  'text.confirmEmail.description':
    "We've sent a 6-digit verification code to {email}.{break}The code expires in 10m, so please enter it soon.",
  'text.confirmPassword': 'Confirm Password',
  'text.contactDetails': 'Contact Details',
  'text.ownerDetails': 'Owner Information',
  'text.converge': 'Converge',
  'text.convergeIntegrationInfo': 'Converge Integration Info',
  'text.copyright': 'Copyright © 2021, {appName} Inc. All rights reserved.',
  'text.couponDetails': 'Coupon Details',
  'text.couponList': 'Coupon List',
  'text.createAccount': 'Create your account',
  'text.creditCard': 'Credit Card',
  'text.customerEmail': 'Customer Email',
  'text.customerList': 'Customer List',
  'text.customerName': 'Customer Name',
  'text.customerPhone': 'Customer Phone',
  'text.date': 'Date',
  'text.dateTime': 'Date & Time',
  'text.OrderPlacedDate': 'Order Placed Date',
  'text.DeliveryDate': 'Delivery Date',
  'text.description': 'Description',
  'text.usage': 'Usage',
  'text.deliveryService': 'Delivery Service',
  'text.didntReceiveCode': "Didn't receive the code?",
  'text.digitalCard': 'Digital Card',
  'text.dontHaveAccount': "Don't have an account?",
  'text.editCustomer': 'Edit Customer',
  'text.email': 'Email',
  'text.expiry': 'Expiry Date',
  'text.exportPhysicalCards': 'Export Physical Cards',
  'text.flatRate': 'Flat Rate',
  'text.comboPrice': 'Combo Price',
  'text.comboDiscount': 'Combo Discount',
  'text.noOfOrder': 'Number Of Orders',
  'text.giftCardBalance': 'Gift Card Balance',
  'text.giftCardDesign': 'Gift Card Design',
  'text.giftCardDetails': 'Gift Card Details',
  'text.giftCardList': 'Gift Card List',
  'text.giftCardNumber': 'Gift Card Number',
  'text.giftCardReport': 'Gift Card Report',
  'text.giftCardStoreDesign': 'Gift Card Store Design',
  'text.giftIssued': 'Gift Issued',
  'text.giftRedeemed': 'Gift Redeemed',
  'text.giftUnredeemed': 'Gift Unredeemed',
  'text.importExternalCards.title': 'Import External Gift Cards',
  'text.importExternalCards.description':
    'Download the excel template from the link below and upload the same for importing the gift cards from other platforms.',
  'text.inactive': 'Inactive',
  'text.integration.clover.change.title': 'Change Account',
  'text.integration.clover.change.description': 'Connect with a different clover merchant account.',
  'text.issueGiftCard': 'Issue Gift Card',
  'text.location': 'Location',
  'text.locations': 'Locations',
  'text.locationDetails': 'Location Details',
  'text.locationList': 'Location List',
  'text.logo': 'Logo',
  'text.logout.content': 'Are you sure you want to logout?',
  'text.name': 'Name',
  'text.notConnected': 'Not Connected',
  'text.operatingHours.delivery': 'Set different operating hours for delivery',
  'text.operatingHours.pickup': 'Set different operating hours for pickup',
  'text.operatingHours.sameAsOpening': '(Same as store hours)',
  'text.onlineStore': 'Online Store',
  'text.ownerProfile.title': 'Owner Profile',
  'text.ownerProfile.description':
    'Tell us about the owner of the business to start your application.',
  'text.paidAmount': 'Paid Amount',
  'text.paymentAccountInfo': 'Payment Account Info',
  'text.paymentDetails': 'Payment Details',
  'text.paymentMethod': 'Payment Method',
  'text.percent': 'Percent',
  'text.percentage': 'Percentage',
  'text.freeItem': 'Free Item',
  'text.permissions': 'Permissions',
  'text.permissions.location': 'Location Permissions',
  'text.physicalCard': 'Physical Card',
  'text.physicalCardDetails':
    'You have purchased {totalCount} physical gift cards and there are {unusedCount} unused cards. Do you want to download the unused cards?',
  'text.pickupService': 'Pickup Service',
  'text.postalCode': 'Postal Code',
  'text.preferences': 'Preferences',
  'text.preview.digitalCard': 'Digital Card Preview',
  'text.recipientDetails': 'Recipient Details',
  'text.recipientName': 'Recipient Name',
  'text.redeemedAmount': 'Redeemed Amount',
  'text.redeemGiftCard': 'Redeem Gift Card',
  'text.register.agreement': 'By signing up, you agree to the',
  'text.reloadGiftCard': 'Reload Gift Card',
  'text.removePickupHour.description': 'Do you want to remove All Pickup Hours',
  'text.removeDeliveryHour.description': 'Do you want to remove All Delivery Hours',
  'text.removeCoupon': 'Remove {code}',
  'text.removeCustomer': 'Remove {customer}',
  'text.removeCustomer.description': 'Are you sure you want to remove this customer?',
  'text.blockCustomer.description': 'Do you want to block and remove this customer?',
  'text.removeCoupon.description': 'Are you sure you want to remove this coupon?',
  'text.removeBlog.description': 'Are you sure you want to remove this blog?',
  'text.removeHour.description': 'Are you sure you want to remove?',
  'text.removeTax': 'Remove {name}',
  'text.removeTax.description': 'Are you sure you want to remove this tax?',
  'text.removeUser': 'Remove {name}',
  'text.removeUser.description': 'Are you sure you want to remove this user?',
  'text.resendGiftCard': 'Resend Gift Card',
  'text.role': 'Role',
  'text.senderDetails': 'Sender Details',
  'text.serialNo': 'S.No.',
  'text.signIn.title': 'Login',
  'text.status': 'Status',
  'text.stepper.businessProfile': 'Business Profile',
  'text.stepper.subscription': 'Subscription',
  'text.storeDetails': 'Store Information',
  'text.holidays': 'Holidays Hours',
  'text.storeAvailability': 'Custom Store Availability',
  'text.taxList': 'Tax List',
  'text.updateCoupon': 'Update Coupon',
  'text.updateBlog': 'Update Blog',
  'text.updateLocation': 'Update Location',
  'text.updateTax': 'Update Tax',
  'text.updateUser': 'Update User',
  'text.user': 'User',
  'text.userDetails': 'User Details',
  'text.userList': 'User List',
  'text.users': 'Users',
  'text.taxes': 'Taxes',
  'text.taxDetails': 'Tax Details',
  'text.transactionHistory': 'Transaction History',
  'text.transactionType': 'Transaction Type',
  'text.totalCount': '{count, plural, =1{1 record} other{# records}}',
  'text.value': 'Value',
  'text.couponValue': 'Coupon Value',
  'text.slno': 'S.No',
  'text.invoiceNumber': 'Invoice Number',
  'text.invoiceDate': 'Invoice Date',
  'text.invoiceStatus': 'Invoice Status',
  'text.analyticsScripts': 'Analytics & Scripts',
  'text.seo': 'SEO',

  'title.website.Websitethemeolor': 'Website Theme Color',
  'title.website.websiteManager': 'Website Manager',
  'title.website.websiteSetup': 'Website Setup',
  'title.website.contactUsSection': 'Contact US Section',
  'title.website.themeDesign': 'Theme and Design',
  'title.website.bannerSection': 'Banner Section',
  'title.website.aboutusSection': 'Aboutus Section',
  'title.website.menuSection': 'Menu Section',
  'title.website.GallerySection': 'Gallery Section',
  'title.website.seo': 'SEO',
  'title.website.analytics': 'Analytics',
  'title.website.socialMedia': 'Social Media',
  'title.website.faqs': 'FAQs',
  'title.website.seosocialmedia': 'SEO & Social Media',
  'title.website.gallery': 'Gallery',
  'title.website.promotion': 'Website Popup',
  'form.label.websiteThemeColor': 'Website Theme Color',
  'title.orderhistory': 'Order History',
  'title.futureOrders': 'Future Orders',
  'title.business': 'Business',
  'title.confirmEmail': 'Confirm Email',
  'title.login': 'Login',
  'title.manage.deliveryRadius': 'Delivery Zones',
  'title.manage.cateringDeliveryRadius': 'Catering Delivery Zones',
  'title.manage.coupon': 'Manage Coupons',
  'title.manage.customer': 'Manage Customers',
  'title.manage.giftCard': 'Manage Gift Cards',
  'title.manage.location': 'Manage Locations',
  'title.manage.tax': 'Manage Taxes',
  'title.manage.user': 'Manage Users',
  'title.manage.blog': 'Manage Blogs',
  'title.manage.employee': 'Manage Employees',
  'title.reports.delivery': 'Delivery Reports',
  'title.reports.inHouseDriver': 'In-House Driver Reports',
  'title.reports.doordashDriver': 'Doordash Delivery Summary',
  'action.addEmployee': 'Add Employee',
  'text.addEmployee': 'Add Employee',
  'text.updateEmployee': 'Update Employee',
  'text.Name': 'Name',
  'text.driverName': 'Driver Name',
  'text.shiftStartTime': 'Shift Start Time',
  'text.shiftEndTime': 'Shift End Time',
  'text.totalOrders': 'Total Orders',
  'text.amountCollected': 'Amount Collected',
  'text.creditDebit': 'Credit/Debit',
  'text.creditDebitTip': 'Credit/Debit Tip',
  'text.deliveryCharges': 'Delivery Charges',
  'text.netBalance': 'Net Balance',
  'text.LoginPin': 'Login Pin',
  'action.inactive': 'In Active',
  'action.active': 'Active',
  'form.label.Status': 'Status',
  'text.removeEmployee': 'Remove Employee',
  'text.removeEmployee.description': 'Do you want to remove this employee?.',
  'text.EmployeeDetails': 'Employee Details',
  'form.placeholder.employee.name': 'Enter the employee name',
  'form.placeholder.employee.loginpin': 'Enter the login pin',
  'form.error.loginpin.length': 'Enter the login pin',
  'form.employeename.required': 'Name Required',
  'form.color.required': 'Color Required',
  'form.error.loginpin.required': 'Login Pin Required',
  'form.loginPin.required': 'Login Pin Required',
  'form.placeholder.search.employee': 'Search by employee name',
  'title.website.ManageDomain': 'Manage Domain',
  'title.manage.OnlineStoreDesign': 'Branding',
  'title.manage.onlineOrrderSetup': 'Online Store Setup',
  'title.manage.posSetup': 'POS Setup',
  'title.manage.orderNumberFormat': 'Order Number Format',
  'form.label.alphanumericOrderNumber': 'Alphanumeric Order Number',
  'form.label.sequentialOrderNumber': 'Sequential Order Number',
  'form.label.automaticRolloverAfter': 'Automatic Rollover After',
  'form.label.resetAfterEODReport': 'Reset After EOD Report',
  'form.label.orderNumber': 'Order Number',
  'form.label.accessDiscount': 'Manager passcode required to access discount',
  'form.label.openCashDrawer': 'Manager passcode required to open cash drawer',
  'form.label.voidItems': 'Manager passcode required to void items or an order',
  'title.manage.printOptions': 'Print Options',
  'form.label.autoPrintAfterOrder': 'Automatically print customer receipt after each order',
  'form.label.printCustomerReceipt':
    'Print order ticket automatically when printing customer receipt',
  'form.label.printTapSave': 'Print order ticket automatically when taping on Save',
  'form.label.printTapPay': 'Print order ticket automatically when taping on Pay',
  'title.manage.general': 'General',
  'form.label.exitAfterSendItem': 'Exit user after sending items to the kitchen',
  'form.label.exitAfterPrintBill': 'Exit user after printing bill',
  'form.label.exitAfterPayment': 'Exit user after payment',
  'form.label.exitAfterIdle': 'Exit user after idle for 5 minutes',
  'title.manage.deviceSettings': 'Device Settings',
  'form.label.enableTestMode': 'Enable test mode',
  'title.manage.eodReportSettings': 'EOD Report Settings',
  'form.label.printEod': 'Allow to print EOD report with open orders',
  'form.label.printSales': 'Print sales overview',
  'form.label.printSalesCategory': 'Print sales by category',
  'form.label.printPayment': 'Print payment summary',
  'form.label.printDiscount': 'Print discount summary',
  'form.label.printVoid': 'Print VOID summary',
  'form.label.printCashDrawer': 'Print cash drawer summary',
  'title.manage.cateringSetup': 'Catering Setup',
  'title.recoverPassword': 'Recover Password',
  'title.resetPassword': 'Reset Password',
  'title.register': 'Register',
  'title.settings.giftCard': 'Gift Card Settings',
  'title.setup.integrations': 'Integrations',
  'title.setup.billing': 'Billing',
  'title.setup.website_widget': 'Website Widget',
  'title.setup.loyalty_discount': 'Loyalty Discount',
  'title.setup.loyalty_setup': 'Loyalty Setup',
  'title.setup.store': 'Store Setup',
  'title.summary.redeem': 'Redeemed Summary',
  'title.summary.sales': 'Sales Summary',
  'title.setup.reports': 'Reports',
  'text.orderList': 'Closed Orders',
  'form.label.yourWebsiteLink': 'Your website link',
  'form.label.websiteDomainUrl': 'Website Domain URL',
  'action.emailToWebMaster': 'Email to my webmaster',
  'form.placeholder.domainurl': 'https://www.example.com',
  'form.changeColor': 'Choose Color',
  'text.instructions': 'Instructions',
  'text.instructionsDesc':
    'You can forward your domain to the above url or you can connect your domain by changing the DNS below - ',

  'text.orderNumber': 'Order#',
  'text.customerInfo': 'Customer Name',
  'text.orderRequested': 'Order Requested',
  'text.orderPlaced': 'Order Placed',
  'text.orderType': 'Order Type',
  'text.orderTotal': 'Order Total',
  'text.closedOrder.search': 'Search by order number or customer name or customer phone',
  'text.futureOrder.search': 'Search by order number or customer name or customer phone',
  'text.recentDate': 'Recent Order Date & Time',

  'action.customOrderType': 'Custom Order Type',
  'text.tenders': 'Tenders',
  'action.customTender': 'Custom Tender',
  'action.customDiscount': 'Custom Discount',
  'text.customerScreenImages': 'Customer Screen Images',
  'action.image': 'Image',

  'text.addZone': 'Add Delivery Zone',
  'text.deliveryRate': 'Delivery Fee',
  'text.deliveryMinimumAmount': 'Delivery Minimum',
  'text.mapShape': 'Zone Type',
  'text.circle': 'Circle',
  'text.square': 'Square',
  'text.custom': 'Custom',
  'text.distance': 'Distance',
  'text.zoneName': 'Zone Name',
  'form.error.deliveryzone.deliveryFees': 'Delivery Fees should be higher than zero',
  'form.error.deliveryzone.deliveryMinimumAmount': 'Delivery Minimum should be higher than zero',
  'form.placeholder.deliveryFees': '0.00',
  'form.placeholder.orderValue': 'Order Value',
  'form.placeholder.zoneName': 'Zone Name',
  'form.placeholder.deliveryMinimumAmount': '0.00',
  'text.deliveryBasedRadius': 'Base delivery radius distance',
  'form.placeholder.deliveryBasedRadius': '0',
  'text.maximumDeliveryDistance': 'Maximum delivery distance',
  'form.label.increaseDeliveryFee': 'Increase delivery fees for every',
  'form.label.by': ' by',
  'form.error.deliverydistance.min': 'Distance must be more than 0',
  'form.placeholder.minimumdistance': '1',
  'form.error.deliveryprice.min': 'Must be more than 0',

  'text.menuAppearance': 'Menu Appearance',
  'text.ordernotifications': 'Order Notifications',
  'text.orderoptions': 'Clover Order Settings',
  'text.siteAppearance': 'Online Store Appearance',
  'text.siteCateringAppearance': 'Catering Store Appearance',
  'text.pickupOptions': 'Pickup Options',
  'text.deliveryOptions': 'Delivery Options',
  'text.ageVerification': 'Age Verification',
  'text.businessNameSection': 'Business Name Section',
  'text.miscellaneous': 'Order Printer Options',
  'text.allergyWarning': 'Customer Notice',
  'text.paymentOptions': 'Payment Options',
  'text.openingHours': 'Store Hours',
  'text.deliveryHours': 'Delivery Hours',
  'text.pickUpService': 'Pickup Service',
  'text.pickUpHours': 'Pickup Hours',
  'text.cateringPickUpHours': 'Catering - Pickup Hours',
  'text.cateringDeliveryHours': 'Catering - Delivery Hours',
  'text.reservationHours': 'Reservation Hours',
  'text.sameasbusinesshours': '(Same as store hours)',
  'text.sameoptiontext': '  Set different operating hours for pickup',
  'text.sameoptiontexttwo': '  Set different operating hours for delivery',
  'text.dealSection': 'Deals Section',
  'text.dineInSection': 'Dine In Options',
  'text.serviceFees': 'Service Fees',
  'text.orderNumberFormat': 'Order Number Format',
  'text.fraudPrevention': 'Fraud Prevention',
  'text.doordashDeliveryFees': 'Doordash Delivery Fees',
  'text.dasherTips': 'Dasher Tips',

  'text.onlineorderingstoredesign': 'Online Ordering Store Design',
  'text.backgroundImage': 'Background Image',
  'text.cardOnline': 'Card(Online)',
  'text.payatcounter': 'Card(Pay at Counter)',
  'text.cash': 'Cash',
  'text.paybycard': 'Card(Pay on Delivery)',
  'text.paydeliverycash': 'Pay on delivery by Cash',
  'text.paydeliverycard': 'Pay on delivery by Card',

  'form.label.prefixOrderType': 'Do you want to add a prefix for Order Types?',
  'form.label.prefix': 'Prefix',
  'form.error.prefix.required': 'Please enter the prefix',
  'form.label.displaymenupicture':
    'Do you want to display menu pictures on your online ordering page?',
  'form.label.displayallergyingredients': 'Do you want to display allergy ingredients?',
  'form.label.displaymenupreferences': 'Do you want to display menu preferences?',
  'form.label.displaycaloriecount': 'Do you want to display menu calorie count?',
  'form.label.websitetheme': 'Kindly choose the website theme color?',
  'form.label.enabledelivery': 'Do you want to enable delivery for your online orders?',
  'form.label.neworderemailalert': 'Do you want to receive email notifications for ASAP online orders?',
  'form.label.neworderscheduledemailalert': 'Do you want to receive email notifications for Scheduled online orders?',
  'form.label.newcateringorderemailalert':
    'Do you want to receive email alerts for new catering orders?',
  'form.label.newcateringreminderemailalert':
    'Do you want to receive reminder email alerts for new catering orders?',
  'form.label.dineinorderemailalert': 'Do you want to receive email alerts for new dine orders?',
  'form.label.confirmordersmsalert':
    'Send SMS notification when an order is ready for pickup or out for delivery?',
  'form.label.notifysmsalert': 'Enable SMS notification',
  'form.label.printOrderRequestTime': 'Print adjusted order requested time on order ticket?',
  'form.label.disableOrderNotes': 'Don`t print order notes on the order ticket?',
  'form.label.disableCustomerNotes': 'Don`t print customer information on the order ticket?',
  'form.label.printOrderByLabel': 'Print order tickets based on clover kitchen labels',
  'form.label.autoconfirm': 'Do you want to auto confirm new orders on clover?',
  'form.label.cateringautoconfirm': 'Do you want to auto confirm new catering orders on clover?',
  'form.label.itemavailability': 'Manage item availability from Clover inventory?',
  'form.label.print_clover_order': 'Do you want to print orders to clover printer?',
  'form.label.catering_print_clover_order':
    'Do you want to print catering orders to clover printer?',
  'form.label.notify_emailid': 'Enter your email address',
  'form.label.newordercallalert': 'Do you want to receive a call alert for new orders?',
  'form.label.notify_mobile_number': 'Enter your phone number',
  'form.label.pickuporderpayments': 'What payment options do you to accept for pickup order?',
  'form.label.deliveryorderpayments': 'What payment options do you to accept for delivery order?',
  'form.label.averagedeliverytime': 'Average Delivery order preparation time',
  'form.label.showtip': 'Do you want to show tip option?',
  'form.label.agerequired': 'What is the minimum age required to place an order?',
  'form.label.age_verification': 'Do you want to enable age verification?',
  'form.label.age_verification_info': 'Age verification message to the customers',
  'form.label.businessNameSection': 'Show business name section on the checkout page?',
  'form.label.allergy_warning': 'Do you want to add a message to your customers?',
  'form.label.allergy_description': 'Customer message',
  'form.label.delivery_warning': 'Do you want to add a message to your delivery customers?',
  'form.label.delivery_description': 'Delivery Order Customer Message',
  'form.label.orderConfirmationMessage': 'Order Confirmation Message',
  'form.placeholder.orderConfirmationMessage': 'Enter your order confirmation message',
  'form.label.acceptpickuporders': 'Do you accept pickup orders on your online ordering page?',
  'form.label.acceptcateringpickuporders':
    'Do you accept pickup orders on your catering ordering page?',
  'form.label.acceptdeliveryorders': 'Do you accept delivery orders on your online ordering page?',
  'form.label.acceptcateringdeliveryorders':
    'Do you accept delivery orders on your catering ordering page?',
  'form.label.acceptpickupasap': 'Do you want to accept ASAP pickup orders?',
  'form.label.acceptdeliveryasap': 'Do you want to accept ASAP delivery orders?',
  'form.label.acceptpickupscheduled': 'Do you want to accept scheduled pickup orders?',
  'form.label.acceptdeliveryscheduled': 'Do you want to accept scheduled delivery orders?',
  'form.label.averagepickuptime': 'Average Pickup order preparation time',
  'form.label.largepickuporders': 'Do you want to set a separate preparation time for large orders',
  'form.label.aboveSubtotal': 'If Order Subtotal is above',
  'form.error.pickupmintotal.min': 'Total must be more than 1',
  'form.placeholder.minimumtotal': '50',
  'form.placeholder.dollar_off': 'Dollar Off',
  'form.placeholder.percentage_off': 'Percentage Off',
  'form.label.increaseTime': ' then increase the average preparation time by',
  'form.label.largedeliveryorders': 'Do you want to set a separate preparation time for large orders',
  'form.label.acceptorder': 'I want to accept',
  'form.label.minutes': 'minutes',
  'form.label.years': 'Years',
  'form.label.isMaximumOrderAmount': 'Do you want to setup a maximum order amount for delivery orders?',
  'form.label.maximumOrderAmount': 'Maximum Order Amount',
  'form.label.isMinimumOrderAmount': 'Do you want to setup a minimum order amount for pickup orders?',
  'form.label.minimumOrderAmount': 'Minimum Order Amount',
  'form.error.pickupminorder.min': 'Order must be more than 1',
  'form.error.deliveryorder.min': 'Order must be more than 1',
  'form.error.pickupinterval.min': 'Must be more than 1 minute',
  'form.error.pickuporderminimumtimeinadvance.min': 'Must be more than 1 minute',
  'form.error.deliverytime.min': 'Must be more than 1 minute',
  'form.error.averagedeliverytime.min': 'Must be more than 1 minute',
  'form.error.deliveryinterval.min': 'Must be more than 1 minute',
  'form.error.orderdaysinadvance.min': 'Must be more than 1 day',
  'form.error.deliveryorderdaysinadvance.min': 'Must be more than 1 day',
  'form.error.averagepickuptime.min': 'Must be more than 1 minute',
  'form.error.deliveryorderminimumtimeinadvance.min': 'must be more than 1 minute',
  'form.error.minimumagereq.min': 'Minimum age required is more than 18 years',
  'form.label.Pickupintervallist': 'pickup orders',
  'form.label.every': ' every',
  'form.label.Deliveryintervallist': 'delivery orders',
  'form.label.minorderinadvance_one': 'I want my clients to order atleast',
  'form.label.minorderinadvance_two': 'minutes',
  'form.label.minorderinadvance_four': 'hours',
  'form.label.minorderinadvance_three': 'in advance',
  'form.label.orderdaysinadvance_one': 'I want my clients to order no more than',
  'form.label.orderdaysinadvance_two': ' days',
  'form.label.orderdaysinadvance_three': 'in advance',
  'form.label.ordertimefornextday_one': 'I want my clients to order before',
  'form.label.print_scheduled_order': 'Print scheduled orders',
  'form.label.print_unlabeled_item': 'Print unlabeled items to',
  'form.label.ordertimefornextday_two': '    for next day orders',
  'form.label.cateringreminderemail': 'Notify before',
  'form.label.miscellaneous.printer': 'Do you want to print customer receipt copy?',
  'form.placeholder.minimumorder': '2',
  'form.placeholder.Pickupintervallist': '15',
  'form.placeholder.deliveryintervallist': '15',
  'form.placeholder.orderdaysinadvance': '7',
  'form.placeholder.averagepickuptime': '90',
  'form.placeholder.averagedeliverytime': '90',
  'form.placeholder.age_verification_info': 'Enter your age verification message to your customers',
  'form.placeholder.allergy_description': 'Enter your message to your customers',
  'form.label.print_customer_copy': 'Order Printer Connected',
  'form.label.noprintername': 'No order printer connected',
  'form.label.printScheduledOrders': 'I want to print the scheduled orders',
  'form.label.printScheduledOrders_two': 'before the order requested time',
  'form.label.neworderTone': 'New order notification tone',
  'form.label.callalert': 'Do you want to receive call alerts whenever an order is not confirmed?',
  'form.label.printcopy': 'Select the number of customer receipt copies to print',
  'form.label.accepttipforpickuporder': 'Do you want to accept tip for pickup orders?',
  'form.label.accepttipfordeliveryorder': 'Do you want to accept tip for delivery orders?',
  'form.label.notify.orderconfirm': 'Notify after',
  'form.label.seperateDeals': 'Do you want to show all the deals as a separate category?',
  'form.label.acceptDineInOrders': 'Do you accept dine in orders on your online ordering page?',
  'form.label.gridView': 'Do you want to show items in grid view?',
  'form.label.categoryImage': 'Do you want to show category image?',
  'form.label.showSavings': 'Show savings on the checkout page',
  'form.label.specialInstructions': 'Do you want to show special instructions for the items?',
  'form.label.orderSpecialInstructions':
    'Do you want to show additional instructions option on the checkout page?',
  'form.label.disableRewards': 'Disable Rewards?',
  'form.label.showPhoneNumber': 'Do you want to show phone number on online ordering page?',
  'form.label.defaulttippercentage': 'Default Tip Percentage',
  'form.label.themeType': 'Theme Type',
  'form.label.zipVerify': 'Zip/Postal code verification required for online payments',
  'form.placeholder.set_tip': 'Set Tip',
  'form.label.service_fees': 'Charge service fees to customers?',
  'form.label.service_fee_amount': 'Service fee amount',
  'form.label.service_fee_percent': 'Service fee percent',
  'form.label.accepttipfordineinorder': 'Do you want to accept tip for dine-in orders?',
  'form.placeholder.dine_in_customer_notes': 'Post order customer notice for table side ordering',
  'form.label.orderNumberFormat': 'Select order number format',
  'form.label.displayVerificationNotes': 'Display ID verification required notice?',
  'form.label.isminimumorder': 'Set a minimum order value restriction to place a catering pickup order',
  'form.label.minimumordervalue': 'Minimum Order Value',
  'form.label.newdeliveryorderemailalert': 'Do you want to send email alerts to the delivery driver?',
  'form.label.newdeliveryordersmsalert': 'Do you want to send SMS alerts to the delivery driver?',

  'form.placeholder.printScheduledOrders': 'Select minutes to print the schedules orders',
  'form.placeholder.neworderTone': 'Select your default new order tone',

  'form.placeholder.notify.mobile': '(855) 558-2345',
  'form.placeholder.notify.emailid': 'hello@familybistro.ca',
  'form.error.start_time.required': 'Please select the start time',
  'form.error.end_time.required': 'Please select the end time',

  'form.placeholder.pickuporderminimumtimeinadvance': '30',
  'form.placeholder.deliveryorderminimumtimeinadvance': '30',
  'form.placeholder.printcustomercopy': 'Select a printer',
  'form.placeholder.printcopy': 'Select your choice',
  'form.placeholder.agerequired': '18',
  'form.placeholder.opening_hours_start_time': 'Start Time',
  'form.placeholder.opening_hours_end_time': 'End Time',
  'form.placeholder.pickup_hours_start_time': 'Start Time',
  'form.placeholder.pickup_hours_end_time': 'End Time',
  'form.placeholder.delivery_hours_start_time': 'Start Time',
  'form.placeholder.delivery_hours_end_time': 'End Time',
  'form.placeholder.set_time': 'Set Time',
  'form.placeholder.set_hour': 'Set Hour',
  'form.placeholder.set_printer': 'Set Printer',
  'form.label.printer': '    printer',

  'message.copyClipboard': 'Copied to clipboard',
  'action.copyStoreUrl': 'Copy Store URL',
  'action.verifyDomain': 'Verify Domain Connection',

  'topBar.issuesHistory': 'Issues History',
  'topBar.projectManagement': 'Project Management',
  'topBar.typeToSearch': 'Search...',
  'topBar.findPages': 'Find pages...',
  'topBar.actions': 'Actions',
  'topBar.status': 'Status',
  'topBar.profileMenu.hello': 'Hello',
  'topBar.profileMenu.billingPlan': 'Billing Plan',
  'topBar.profileMenu.role': 'Role',
  'topBar.profileMenu.business': 'Business',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Phone',
  'topBar.profileMenu.editProfile': 'Edit Profile',
  'topBar.profileMenu.logout': 'Logout',
  'form.label.reviewRequest': 'Would you like to request reviews?',
  'form.label.reviewLink': 'Review Link',
  'form.placeholder.reviewLink': 'Enter the review link URL',
  'text.changeAddress': 'Update Delivery Address',
  'text.changeDateTime': 'Update Order Due Time',
  'form.label.address.new': 'Enter Delivery Address',
  'form.error.address.required': 'Please input the delivery address',
  'form.label.suite': 'Apartment No./Suite',
  'form.label.buzzerCode': 'Buzzer Code',
  'form.placeholder.suite': 'Apartment No./Suite (Optional)',
  'form.placeholder.buzzerCode': 'Buzzer Code (Optional)',
  'form.label.alcoholLimit': 'Do you want to enable Alcohol purchase limit per order?',
  'form.label.maximumVolumeOunce': 'Maximum Alcohol Volume (oz) / Order',
  'form.placeholder.maximumVolumeOunceText': 'Enter the total alcohol volume per order',
  'form.label.volumeOunce': 'Alcohol Volume (oz)',
  'form.placeholder.volumeOunceText': 'Enter the total alcohol volume for this item',
}

export default {
  locale: 'en-US',
  localeAntd,
  messages,
}
